module.exports = __webpack_public_path__ + "static/img/img-home-co-21.b3ed889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-21.png
// module id = Hogr
// module chunks = 1